import { SuretyAccountId, SuretyAccountUnderwritingStatus } from "@inrev/common";
import { useFetchLatestSuretyAccountUnderwriting } from "@portal/api/account";
import { ProcessingBanner } from "@portal/components/features/banners";
import { FC } from "react";

type AccountProcessingBannerProps = {
	accountId: SuretyAccountId;
};

export const AccountProcessingBanner: FC<AccountProcessingBannerProps> = ({ accountId }) => {
	const { latestUnderwriting, latestUnderwritingIsLoading, latestUnderwritingError } =
		useFetchLatestSuretyAccountUnderwriting(accountId);

	if (latestUnderwritingIsLoading || latestUnderwritingError) {
		return null;
	}

	if (latestUnderwriting?.status !== SuretyAccountUnderwritingStatus.processing) {
		return null;
	}

	return (
		<ProcessingBanner
			testId="agent-account-processing-banner"
			title="Analyzing Financial Data"
			description="Financial data is being extracted and analyzed. The account review will complete automatically once processing is finished."
		/>
	);
};
